export const PROPAGANDA_ITEMS = [
  {
    id: 1,
    title: "Share The Love",
    description:
      "Share your unique referral link or code with your friends via email, text or on social media.",
    iconColor: "neon"
  },
  {
    id: 2,
    title: "Remind Your Friends",
    description:
      "Encourage your friends to redeem their free $5 toward their first purchase of any card sitewide.",
    iconColor: "black"
  },
  {
    id: 3,
    title: "Earn GCX Cash",
    description:
      "When they make a purchase within 30 days of signing up, we’ll deposit $5 into your GCX account.",
    iconColor: "pink"
  }
];
